<template>
    <div>
        <b-form-input
                :id="tag"
                :name="tag"
                type="text"
                v-mask="'####-##-##'"
                v-model="value"
                :list="'date_list__' + tag"
                :state="null"
                :placeholder="placeholder"
                @change="onChange"
                @keyup.esc="onKeyEsc"
                @keyup.enter="onKeyEnter"
                @focus.native="onFocus"
                :disabled="disabled || committed"
                size="sm"
                v-bind:class="{itempropertyupdated: isUpdated, invalidinput: isInvalid}"
                :style="'min-width: ' + bestCellWidth(value, tag) + '; text-align: center;'">
        >
        </b-form-input>

        <datalist :id="'date_list__' + tag">
            <option v-for="(date, index) in dates" :key="index">{{ date }}</option>
        </datalist>
    </div>
</template>

<script>
    import cellTypeMixin from './CellTypeMixin.vue'
    import inputCellMixin from './InputCellMixin.vue'
    export default {
        mixins: [cellTypeMixin, inputCellMixin],
        props: {
            tag: {
                type: String,
                required: true
            },
            validation: {
                type: Object
            },
            brandId: {
                type: Number|String,
                required: true
            },
            countryId: {
                type: String,
                required: true
            },
            route: {
                type: String,
                required: true
            },
            storedData: {
                type: String|Number,
                default: null
            },
            placeholder: String,
            disabled: {
                type: Boolean,
                default: false
            },
            committed: {
                type: Boolean,
                default: false
            },
            gridItemIndex: {
                type: Number,
                required: true
            }
        },

        computed: {
            dates () {
                return this.$store.state.dates
            }
        },
    }
</script>
